
import React from 'react';

export const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            문의하기
          </h2>
          <p className="text-lg text-gray-600">
            궁금한 점이 있으시면 언제든지 연락해주세요
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {/* 연락처 정보 */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">연락처 정보</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-green-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-white text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">주관 기관</h4>
                <p className="text-gray-600">대청마을 북측 모아타운 사업성 평가 위원회</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-green-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-white text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">운영시간</h4>
                <p className="text-gray-600">평일 10:00 ~ 17:00</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-green-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-white text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">주소</h4>
                <p className="text-gray-600">서울 강남구 일원동 대청마을 북측 구역</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};